import React from "react";
import { MenuItem } from "../../types/Menu";
import { isActive } from "../DesktopMenu/_/selectedMenuItem";
import { MobileMenuItem } from "../MobileMenuItem";
import { MobileSubmenuItem } from "../MobileSubmenuItem";

interface MobileMenuItemsProps {
  items: MenuItem[];
  currentPath: string;
  onItemClick: () => void;
}

export const MobileMenuItems: React.FC<MobileMenuItemsProps> = ({
  items,
  currentPath,
  onItemClick,
}) => (
  <>
    {items.map(item =>
      item.subMenu ? (
        <MobileSubmenuItem
          key={item.title}
          item={item}
          currentPath={currentPath}
          onItemClick={onItemClick}
          active={isActive(currentPath, item)}
        />
      ) : (
        <MobileMenuItem
          key={item.title}
          item={item}
          currentPath={currentPath}
          onItemClick={onItemClick}
          active={isActive(currentPath, item)}
        />
      ),
    )}
  </>
);
